import { StandardsModalTabs } from "./StandardsModalTabs.component";

export { StandardsModalTabs };
